export default __webpack_public_path__ + "img/eddb86eb9fe2a7b8983e09968cd3a027.svg";